<template>
    <v-dialog v-model="visible" max-width="500">
        <v-card v-if="corrente">
            <v-card-title>
                <span>{{ corrente.titolo }}</span>
                <span v-if="totale > 1" class="msp-annuncio-ui__contatore">{{ indice + 1 }}/{{ totale }}</span>
            </v-card-title>
            <v-card-text>
                <div class="msp-annuncio-ui__testo" v-html="testoHtml"></div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="next">
                    {{ haSuccessivo ? 'Successivo' : 'Chiudi' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { marked } from 'marked';
import api from '@mixins/api.js';

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
const endpoint = `${apiBaseUrl}/api/v2/annuncio_ui.php`;

export default {
    name: 'MspAnnuncioUi',
    data() {
        return {
            visible: false,
            pending: [],
            indice: 0,
        };
    },
    computed: {
        totale() {
            return this.pending.length;
        },
        corrente() {
            return this.pending[this.indice] || null;
        },
        haSuccessivo() {
            return this.indice < this.totale - 1;
        },
        testoHtml() {
            if (!this.corrente) return '';
            return marked.parse(this.corrente.testo || '');
        },
    },
    watch: {
        // SPA: ogni navigazione può portare su una pagina con annunci diversi
        '$route.name': function () {
            this.load();
        },
        // chiusura anticipata (tap fuori dal dialog/ESC): marca visto solo l'annuncio
        // mostrato in quel momento, i successivi restano pendenti e ricompariranno
        visible: function (isVisible) {
            if (!isVisible && this.corrente) {
                this.markVisto(this.corrente.id);
                this.pending = [];
                this.indice = 0;
            }
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            // se l'utente naviga via mentre il popup della pagina precedente è ancora
            // aperto, lo si considera "chiuso a metà": marca l'annuncio corrente visto
            // (il watcher su `visible` se ne occupa) prima di caricare quelli nuovi
            if (this.visible) {
                this.visible = false;
            }
            const pagina = this.$route && this.$route.name;
            if (!pagina) return;
            const result = await api(`${endpoint}?pagina=${encodeURIComponent(pagina)}&piattaforma=mobile`, 'GET');
            const annunci = (result && result.success) ? result.data : null;
            if (!annunci || !annunci.length) return;
            this.pending = annunci;
            this.indice = 0;
            this.visible = true;
        },
        markVisto(id) {
            // fire-and-forget: in caso di errore l'annuncio ricompare al prossimo
            // ingresso in pagina, non è un esito critico
            api(endpoint, 'POST', { annuncio_id: id });
        },
        next() {
            if (this.haSuccessivo) {
                this.markVisto(this.corrente.id);
                this.indice++;
            } else {
                this.visible = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.msp-annuncio-ui__contatore {
    margin-left: auto;
    font-size: 0.8rem;
    opacity: 0.7;
}
.msp-annuncio-ui__testo {
    :deep(img) {
        max-width: 100%;
        border-radius: 4px;
        margin: 0.5rem 0;
    }
    :deep(p) {
        margin: 0.5rem 0;
    }
}
</style>
